import React from 'react';

const responsibilitiesData = [
  {
    title: 'Develop and Implement Marketing Strategies:',
    description: [
      'Create and oversee the execution of comprehensive marketing strategies tailored to the biopharma/ life science industry.',
      'Develop marketing plans that support the launch and growth of biopharma/ life science products.',
    ],
  },
  {
    title: 'Product Launches:',
    description: [
      'Lead the planning and execution of product launches, including market analysis, positioning, and promotional strategies.',
      'Coordinate cross-functional teams to ensure successful product introductions.',
    ],
  },
  {
    title: 'Campaign Management:',
    description: [
      'Plan and manage multi-channel marketing campaigns, including digital, print, and event-based marketing.',
      'Monitor and analyze campaign performance metrics, making data-driven adjustments as necessary.',
    ],
  },
  {
    title: 'Brand Management:',
    description: [
      'Maintain and enhance the company’s biopharma/ life science brand through consistent messaging and visual identity.',
      'Ensure brand guidelines are adhered to across all marketing materials and communications.',
    ],
  },
  {
    title: 'Content Creation:',
    description: [
      'Collaborate with the medical and regulatory teams to develop compliant, engaging, and relevant content for various platforms, including websites, medical journals, social media, and email marketing.',
      'Manage the production of marketing materials, including brochures, press releases, and promotional products.',
    ],
  },
];

const Responsibilities = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-grow">
        <div className="fredoka text-[24px] font-medium leading-normal tracking-[-0.48px] text-[#012E33]">
          Responsibilities
        </div>
        <div className="mt-4">
          {responsibilitiesData.map((item, index) => (
            <div key={index} className="mt-6">
              <div className="fredoka text-[18px] font-normal leading-[26px] tracking-[-0.36px] text-[#678285]">
                {item.title}
              </div>
              <ul className="fredoka mt-2 list-disc pl-5 text-[18px] font-normal leading-[26px] tracking-[-0.36px] text-[#678285]">
                {item.description.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Apply Now Button */}
      <div className="sticky bottom-1 mt-4 box-border flex h-1/2 w-full rounded-[16px] bg-[#FC823E] py-[10px] text-center font-medium text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] lg:hidden">
        <a href="#hellomom" className="w-full px-4">
          Apply Now
        </a>
      </div>
    </div>
  );
};

export default Responsibilities;
